import { Component, Input } from '@angular/core';

export type StatCardVariant = 'brand' | 'accent' | 'ok' | 'info';
export type StatCardIcon = 'check' | 'pause' | 'users' | 'card';

@Component({
  selector: 'app-stat-card',
  templateUrl: './stat-card.component.html',
  styleUrls: ['./stat-card.component.css'],
  standalone: false
})
export class StatCardComponent {
  @Input() label: string = '';
  @Input() value: string | number | null | undefined = null;
  /** One of the named outline icons the template switches on — not a raw emoji/glyph,
   *  so every stat card renders the same themed icon style instead of relying on
   *  whatever emoji font the OS/browser happens to render. */
  @Input() icon: StatCardIcon | '' = '';
  @Input() variant: StatCardVariant = 'brand';
  /** Optional explanation of how the count is calculated — shown as an ⓘ icon beside the
   *  label with a tooltip on hover/focus, and toggled on tap for touch devices. */
  @Input() info: string = '';
}
